<script setup lang="ts">
import type { DocumentationRow } from '@/models/current-student-advanced-standing-form/documentation'
import DocumentationRequirementsTable from '@/components/current-student-advanced-standing-form/documentation/DocumentationRequirementsTable.vue'

defineProps<{
  rows: DocumentationRow[]
  errorMessage: string
}>()
</script>

<template>
  <fieldset>
    <legend>Documentation</legend>
    <p>
      Please check that all relevant documentation has been attached.
      Failure to provide correct documentation may cause your application to be rejected or delayed.
    </p>
    <div class="table-responsive">
      <DocumentationRequirementsTable :rows="rows" />
      <div class="alert alert-danger" id="DocumentationErrorBox">{{ errorMessage }}</div>
    </div>
  </fieldset>
</template>
